export default "<%- text %>\n";